// eslint-disable-next-line
import React, { ReactElement, useState } from 'react';
import { Typography, Divider } from '@mui/material';
import { Luminary } from '../../types/luminary';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Close, Done } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import { DEVICE_TYPE } from '../enum/ENUM';
import { formatDateTime } from '../../lib/date-time-formatter';

type Props = {
    luminary: Luminary;
    deviceType?: string;
};

export const LuminaryTests: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {
    const { t } = useLanguageLocale();
    const getTestStatusIconText = (status: boolean): { icon: ReactElement; text: string } => {
        return status ?
            {
                icon: <Done style={{ color: '#39B620' }} />,
                text: t('SYSTEM_DETAIL.DURATION_TEST_PASSED')
            } :
            {
                icon: <Close style={{ color: '#CA3C3D' }} />,
                text: t('SYSTEM_DETAIL.DURATION_TEST_FAILED')
            };
    }

    return (
        <>
            <div style={{ flex: '1 1 0px', overflow: 'auto' }} data-testid="device-luminary-details-tests-container">

                <DeviceTest
                    data-testid='luminary-test-dt-duration'
                    header={t('DEVICE_DETAILS.RATED_DURATION')}
                    title={props.luminary.testDuration ? props.luminary.testDuration : '--'}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />

                <div style={{ marginTop: 16 }}></div>

                <DeviceTest
                    data-testid='luminary-test-dt-acual'
                    header={t('DEVICE_DETAILS.DURATION_RESULT')}
                    title={props.luminary.luminaryDTActual ? props.luminary.luminaryDTActual + ' ' + t('COMMON.MINUTES') : '--'}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />

                <div style={{ marginTop: 16 }}></div>

                <DeviceTest
                    data-testid='luminary-test-dt-prev'
                    header={t('DEVICE_DETAILS.PREVIOUS_DURATION_TEST')}
                    title={props.deviceType === DEVICE_TYPE.DEVICE_TYPE_WIRELESS ? formatDateTime(props.luminary.durationTestPrevious) || '--' : props.luminary.durationTestPrevious || '--'}
                    testStatusIcon={getTestStatusIconText(props.luminary.dtStatus).icon}
                    testDescription={getTestStatusIconText(props.luminary.dtStatus).text}
                    isDisplayDescription={true}
                />

                <div style={{ marginTop: 16 }}></div>

                <DeviceTest
                    data-testid='luminary-test-group-prev'
                    header={t('DEVICE_DETAILS.TEST_GROUP')}
                    title={props.luminary.testGroupId?.toString() ?? '--'}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />

                <DeviceTest
                    data-testid='luminary-test-interval90-prev'
                    header={t('COMMON.INTERVAL')}
                    title={`${t('COMMON.EVERY')} ${props.luminary.luminaryDTInterval ?? '0'} ${t('COMMON.DAYS')}`}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />

                <div style={{ marginTop: 16 }}></div>

                <Divider />

                <div style={{ marginTop: 16 }}></div>

                {props.deviceType !== DEVICE_TYPE.DEVICE_TYPE_CGLINE && <DeviceTest
                    data-testid='luminary-test-ft-delay'
                    header={t('DEVICE_DETAILS.FUNCTIONAL_TEST_DURATION')}
                    title={props.luminary.luminaryFTDuration ? props.luminary.luminaryFTDuration + ' ' + t('COMMON.MINUTES') : '--'}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />}

                <div style={{ marginTop: 16 }}></div>

                <DeviceTest
                    data-testid='luminary-test-ft-prev'
                    header={t('DEVICE_DETAILS.PREVIOUS_FUNCTIONAL_TEST')}
                    title={props.deviceType === DEVICE_TYPE.DEVICE_TYPE_WIRELESS ? formatDateTime(props.luminary.functionalTestPrevious) || '--' : props.luminary.functionalTestPrevious || '--'}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={false}
                />

                <div style={{ marginTop: 16 }}></div>

                <DeviceTest
                    data-testid='luminary-test-interval7-prev'
                    header={t('COMMON.INTERVAL')}
                    title={`${t('COMMON.EVERY')} ${props.luminary.luminaryFTInterval ?? '0'} ${t('COMMON.DAYS')}`}
                    testStatusIcon={''}
                    testDescription={''}
                    isDisplayDescription={true}
                />

            </div >
        </>
    );
};

const DeviceTest: React.FC<React.PropsWithChildren<React.PropsWithChildren<{ header: string, title: string, testStatusIcon: any, testDescription: string, isDisplayDescription: boolean }>>> = (props) => {
    return (
        <div style={{ margin: 16 }}>
            <Typography variant="body2" style={{ fontSize: 12 }} id="luminary-test-header" data-testid="luminary-test-header" >{props.header}</Typography>
            <Typography variant="body2" style={{ fontSize: 14, fontWeight: 600 }} id="luminary-test-title" data-testid="luminary-test-title" >{props.title}</Typography>
            {props.isDisplayDescription && <Chip id="luminary-test-description" style={{ backgroundColor: '#FFFFFF', color: '#424E54', fontSize: 12, margin: 0 }} icon={props.testStatusIcon} label={props.testDescription} />}
        </div>
    );
};
